<script>
export default {
    components: {},
};
</script>

<template>
<div>
    <div class="account-pages pt-1">
        <div class="col-12">
            <slot />
        </div>
    </div>
</div>
</template>
